export default __webpack_public_path__ + "locales/el-GR/MainBar.json?hash=7f77c69cd71d886ed2922edde28aa1e7";